import Payment from 'models/Payment'
import { currency, date } from 'helpers/format'

export default class PaymentBreakdown extends Payment {
  // DEPOSITS
  get proofOfPayment() {
    return this.model.proofOfPayment
  }

  get lessorName() {
    return this.model.lessorName
  }

  get vendorCode() {
    return this.model.vendorCode
  }

  get chequeNumber() {
    return this.model.checkNo
  }

  get chequeClearingDate() {
    return date(this.model.chequeClearingDate, 'MMM dd, yyyy')
  }

  get trackingNumber() {
    return this.model.trackingNumber
  }

  get deliveredTo() {
    return this.model.deliveredTo
  }

  get deliveredDate() {
    return date(this.model.deliveredDate)
  }

  get receivedBy() {
    return this.model.receivedBy
  }

  get relationship() {
    return this.model.relationship
  }

  // GCash
  get beneficiaryNumber() {
    return this.model.beneficiaryNumber
  }

  get referenceNumber() {
    return this.model.referenceNumber
  }

  // Bank
  get beneficiaryBankName() {
    return this.model.beneficiaryBankName
  }

  get beneficiaryBankAccountNo() {
    return this.model.beneficiaryBankAccountNo
  }

  // Format currency
  get vat() {
    return currency(this.model.vat)
  }

  get isNonVat() {
    if (this.model.vat === 'Non-VAT') {
      return true
    }
    return false
  }

  get withholdingTax() {
    return currency(this.model.withholdingTax)
  }

  // Other
  get processedDate() {
    return date(this.model.datePaid, 'MMM dd, yyyy')
  }

  get paymentStartDate() {
    return date(this.model.termFrom, 'MMM dd, yyyy')
  }

  get paymentEndDate() {
    return date(this.model.termTo, 'MMM dd, yyyy')
  }
}
